import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NoticeActions from '../actions/NoticeActions';
import SystemMessageActions from '../actions/SystemMessageActions';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import SystemMessage from '@bibliocommons/shared-system-message';
import { getVisibleMessages } from '../selectors/SystemMessageSelector';


function mapStateToProps(state) {
  return {
    localBranch: !!state.getIn(['app', 'localBranch']),
    systemMessages: getVisibleMessages(state)
  };
}

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  systemMessages: ImmutablePropTypes.list.isRequired,
  localBranch: PropTypes.bool,
  priority: PropTypes.string.isRequired
};

class SystemMessagesContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderMessage');
    this.systemMessageActions = bindActionCreators(SystemMessageActions, props.dispatch);
    this.noticeActions = bindActionCreators(NoticeActions, props.dispatch);
  }

  componentDidMount() {
    this.systemMessageActions.fetchSystemMessages(this.props.priority);
  }

  renderMessage(message) {
    const { localBranch } = this.props;
    return (
      <SystemMessage key={message.get('id')} message={message} dismissable={!localBranch} noticeActions={this.noticeActions} />
    );
  }

  render() {
    return (
      <div>
        { this.props.systemMessages.valueSeq().map(this.renderMessage) }
      </div>
    );
  }
}

SystemMessagesContainer.propTypes = propTypes;

export default connect(mapStateToProps)(SystemMessagesContainer);



// WEBPACK FOOTER //
// ./app/containers/SystemMessagesContainer.jsx